<template>
  <div
    class="border border-gray-200 transition rounded-lg overflow-hidden flex items-center gap-3"
    :class="props.readonly ? '' : 'hover:bg-gray-50 cursor-pointer'"
    @click="props.readonly ? null : $emit('click')"
  >
    <div class="w-24 h-16 shrink-0 bg-gray-100 flex items-center justify-center overflow-hidden">
      <img
        v-if="thumbnailUrl"
        :src="thumbnailUrl"
        :alt="props.template.name"
        class="w-full h-full object-cover object-top"
      >
      <Icon
        v-else
        :name="props.template.type === 'email' ? 'mail-01' : 'file-06'"
        class="text-blue-500 w-5 h-5"
      />
    </div>
    <div class="flex-1 min-w-0 py-3">
      <div class="text-sm font-medium text-gray-900 truncate">
        {{ props.template.name || useT('bcd337') }}
      </div>
      <div class="text-xs text-gray-500 capitalize">
        {{ props.template.type }}
      </div>
    </div>
    <Icon
      v-if="!props.readonly"
      name="chevron-right"
      class="text-gray-400 shrink-0 mr-3"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  template: {
    type: Object,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['click']);

const thumbnailUrl = computed(() => {
  const raw = props.template.thumbnail;
  if (!raw) return '';
  const imagekit = useRuntimeConfig().public.imagekit;
  if (!imagekit) return raw;
  return `${imagekit}/tr:w-192,h-128,c-at_max,fo-top/${raw}`;
});
</script>
